<button
  pButton
  type="button"
  [label]="title | translate"
  class="p-button-secondary secondary-btn {{size}}"
  icon="pi pi-{{ icon }}"
  [disabled]="disable"
  [loading]="loading"
  [size]="size"
  (click)="action.emit()"
  [style]="{ width: width}"
>
</button>
